import script from "./BookingForm.vue?vue&type=script&setup=true&lang=js"
export * from "./BookingForm.vue?vue&type=script&setup=true&lang=js"

import "./BookingForm.vue?vue&type=style&index=0&id=3dfaed9e&scoped=true&lang=css"

import exportComponent from "/var/www/html/projects/petcare_admin_panel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3dfaed9e"]])

export default __exports__